import { useEffect, useState } from "react";
import { ArrowUp, ArrowDown, Eye, EyeOff } from "lucide-react";
import { api } from "../../../lib/api";
import { toast } from "sonner";

export default function ContentAdmin() {
    const [sections, setSections] = useState([]);

    const load = () => api.get("/admin/sections").then((r) => setSections(r.data)).catch(() => {});
    useEffect(() => {
        load();
    }, []);

    const move = async (index, dir) => {
        const ids = sections.map((s) => s.id);
        const [moved] = ids.splice(index, 1);
        ids.splice(index + dir, 0, moved);
        setSections(ids.map((id) => sections.find((s) => s.id === id)));
        await api.post("/admin/sections/reorder", { ids }).catch(() => toast.error("Reorder failed"));
    };

    const toggle = async (s) => {
        try {
            await api.put(`/admin/sections/${s.id}`, { key: s.key, title: s.title, visible: s.visible === false });
            toast.success(s.visible === false ? "Section shown" : "Section hidden");
            await load();
        } catch {
            toast.error("Could not update section");
        }
    };

    return (
        <div data-testid="admin-content">
            <h2 className="font-heading font-extrabold text-lg text-slate-900 mb-1">Homepage sections</h2>
            <p className="text-xs text-slate-500 mb-4">
                Reorder or hide homepage sections. Product photos and category images can be changed in the Products and Categories sections.
            </p>
            <div className="bg-white rounded-2xl border border-slate-200 divide-y divide-slate-100" data-testid="admin-sections-list">
                {sections.map((s, i) => (
                    <div key={s.id} className="flex items-center gap-4 p-4" data-testid={`section-row-${s.key}`}>
                        <div className="flex flex-col">
                            <button type="button" disabled={i === 0} onClick={() => move(i, -1)} aria-label="Move up"
                                data-testid={`section-up-${s.key}`} className="text-slate-400 hover:text-[#0033A0] disabled:opacity-20">
                                <ArrowUp className="h-4 w-4" />
                            </button>
                            <button type="button" disabled={i === sections.length - 1} onClick={() => move(i, 1)} aria-label="Move down"
                                data-testid={`section-down-${s.key}`} className="text-slate-400 hover:text-[#0033A0] disabled:opacity-20">
                                <ArrowDown className="h-4 w-4" />
                            </button>
                        </div>
                        <div className="flex-1">
                            <p className="font-heading font-bold text-slate-900">{s.title}</p>
                            <p className="text-xs text-slate-400">{s.key}</p>
                        </div>
                        {s.visible === false && (
                            <span className="rounded-full bg-slate-200 text-slate-600 text-xs font-bold px-3 py-1">Hidden</span>
                        )}
                        <button type="button" onClick={() => toggle(s)} data-testid={`section-toggle-${s.key}`}
                            aria-label={s.visible === false ? "Show section" : "Hide section"}
                            className="p-2 rounded-full text-slate-500 hover:bg-slate-100">
                            {s.visible === false ? <Eye className="h-4 w-4" /> : <EyeOff className="h-4 w-4" />}
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
}
